import e400 from '../assets/Error/400.png';
import e401 from '../assets/Error/401.png';
import e403 from '../assets/Error/403.png';
import e404 from '../assets/Error/404.png';
import e408 from '../assets/Error/408.png';
import e409 from '../assets/Error/409.png';
import e422 from '../assets/Error/422.png';
import e429 from '../assets/Error/429.png';
import e500 from '../assets/Error/500.png';
import e502 from '../assets/Error/502.png';
import e503 from '../assets/Error/503.png';
import e504 from '../assets/Error/504.png';
import eNetwork from '../assets/Error/network.png';
import eTimeout from '../assets/Error/timeout.png';
import eParse from '../assets/Error/parse.png';
import eAuth from '../assets/Error/auth.png';
import eUnknown from '../assets/Error/unknown.png';

export const errorConfig = {
  400: {
    title: "Bad Request",
    message: "The server could not understand your request.",
    image: e400,
  },
  401: {
    title: "Unauthorized",
    message: "You are not authorized to access this resource.",
    image: e401,
  },
  403: {
    title: "Forbidden",
    message: "Access to this resource is forbidden.",
    image: e403,
  },
  404: {
    title: "Page Not Found",
    message: "The page you are looking for does not exist.",
    image: e404,
  },
  408: {
    title: "Request Timeout",
    message: "The server timed out waiting for the request.",
    image: e408,
  },
  409: {
    title: "Conflict",
    message: "A conflict occurred. Please try again later.",
    image: e409,
  },
  422: {
    title: "Unprocessable Entity",
    message: "Your request was well-formed but contains semantic errors.",
    image: e422,
  },
  429: {
    title: "Too Many Requests",
    message: "You have made too many requests in a short time.",
    image: e429,
  },
  500: {
    title: "Server Error",
    message: "Something went wrong on our end.",
    image: e500,
  },
  502: {
    title: "Bad Gateway",
    message: "Received an invalid response from the upstream server.",
    image: e502,
  },
  503: {
    title: "Service Unavailable",
    message: "The server is temporarily unavailable. Please try again later.",
    image: e503,
  },
  504: {
    title: "Gateway Timeout",
    message: "The server did not receive a timely response.",
    image: e504,
  },
  network: {
    title: "Network Error",
    message: "Please check your internet connection.",
    image: eNetwork,
  },
  timeout: {
    title: "Timeout",
    message: "The request took too long. Please try again.",
    image: eTimeout,
  },
  parse: {
    title: "Parsing Error",
    message: "There was a problem parsing the response.",
    image: eParse,
  },
  auth: {
    title: "Authentication Error",
    message: "Your session has expired or is invalid.",
    image: eAuth,
  },
  unknown: {
    title: "Unknown Error",
    message: "An unexpected error has occurred.",
    image: eUnknown,
  },
} as const;
